export var lockCommandLogs = {
  name: "锁车指令日志",
  path: "/lock-command-logs",
  hidden: false,
  redirect: "noredirect",
  component: "Layout",
  elemCode: "6",
  sort: 4,
  alwaysShow: true,
  meta: {
    title: "锁车指令日志",
    icon: "education",
    noCache: false
  },
  children: [{
    name: "LockCommandLogs",
    path: "/lock-command-logs/index",
    hidden: false,
    component: "lockCommandLogs/index",
    elemCode: "7",
    meta: {
      title: "锁车指令日志",
      noCache: true
    }
  }]
};